module.exports = __webpack_public_path__ + "static/media/ico_discount.6e679918.png";